<script>
    import { onMount, onDestroy } from "svelte";
    import { scale } from 'svelte/transition';
    import { quintOut } from 'svelte/easing';

    import { idb } from "../db";
    import { recentIDB } from '../store/recent';

    import { user } from '../store/authStore';
    import { lists } from '../store/lists';
    import { recurring } from '../store/recurring'
    import { stores } from '../store/stores';
    import { page, modal } from '../store/nav';

    import Searchbox from "../components/searchbox.svelte";
    import AutoComplete from "simple-svelte-autocomplete"

    export let list_uid;
    export let item_uid;

    let selectedOption;
    let text;
    let recentStores = [];

    const createNewRetailer = async (name) => {
        modal.open(`/new-store?list_uid=${list_uid}&name=${name}&anchor=bottom`);
    };

    const setRetailer = async s => {
        await recentIDB.add(`stores`,s);
        if ( list_uid == `recurring` ) {
            await recurring.init(item_uid);
            await recurring.editSingleField(item_uid, `storeUid`, s.uid);
            await recurring.editSingleField(item_uid, `storeName`, s.name.toLowerCase());
            await recurring.editSingleField(item_uid, `storeLogo`, s.logoId);
            page.back(`/lists/recurring`);
        } else {
            await lists.editSingleField(list_uid, 'storeUid', s.uid);
            await lists.editSingleField(list_uid, 'storeName', s.name.toLowerCase());
            await lists.editSingleField(list_uid, 'storeLogo', s.logoId);
            await idb.save('pc_lists', $lists);
            page.back(`/lists/items?list_uid=${list_uid}`);
        }
    };

    onMount(async ()=>{
        await recentIDB.init(`stores`);
        if ( $recentIDB ) {
            recentStores = $recentIDB.entries;
            console.group(`INFO: /select-store.onMount`);console.log(`recentStores`);console.log(recentStores);console.groupEnd()
        }
        await stores.init();
    });
    onDestroy(() => {
        idb.save('pc_lists', $lists);
    });
</script>

<section id="list" in:scale="{{delay: 250, duration: 300, easing: quintOut }}" out:scale="{{delay: 250, duration: 300, easing: quintOut }}" class="z-0 fixed top-0 left-0 h-screen w-screen font-primaryBold text-primary flex flex-col space-y-8 pt-5 pl-7 bg-secondary" >
    <section id="top-bar" class="flex pr-7 justify-between items-stretch ">
        <div id="back-btn" class="" on:click={page.referrer} >
            <svg viewBox="0 0 18 18" class="fill-primary mt-3.5 h-5" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.7803 2.46967C12.0732 2.76256 12.0732 3.23744 11.7803 3.53033L6.31066 9L11.7803 14.4697C12.0732 14.7626 12.0732 15.2374 11.7803 15.5303C11.4874 15.8232 11.0126 15.8232 10.7197 15.5303L4.71967 9.53033C4.42678 9.23744 4.42678 8.76256 4.71967 8.46967L10.7197 2.46967C11.0126 2.17678 11.4874 2.17678 11.7803 2.46967Z"/>
            </svg>
        </div>
        <div id="title" class="place-self-center font-primaryXBold text-lg">Select Store</div>
        <div id="title-menu"class="w-10 h-12 place-self-center" >
            <svg class="fill-primary mt-3.5 m-auto" width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.5 3C10.5 3.82843 9.82843 4.5 9 4.5C8.17157 4.5 7.5 3.82843 7.5 3C7.5 2.17157 8.17157 1.5 9 1.5C9.82843 1.5 10.5 2.17157 10.5 3Z"/>
                <path d="M10.5 9C10.5 9.82843 9.82843 10.5 9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9Z"/>
                <path d="M9 16.5C9.82843 16.5 10.5 15.8284 10.5 15C10.5 14.1716 9.82843 13.5 9 13.5C8.17157 13.5 7.5 14.1716 7.5 15C7.5 15.8284 8.17157 16.5 9 16.5Z"/>
            </svg>
        </div>
    </section>

    <!--section id="profile-details" class="">
        <div id="profile-name" class="text-3xl font-secondary ">
            Lists
        </div>
        <div class="bg-secondary w-10 h-10 place-self-center rounded-full text-center" >
            <svg class="m-auto mt-3 w-4 fill-accent" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.75 0.75C6.75 0.335786 6.41421 0 6 0C5.58579 0 5.25 0.335786 5.25 0.75V5.24993L0.75 5.24993C0.335786 5.24993 0 5.58572 0 5.99993C0 6.41414 0.335786 6.74993 0.75 6.74993L5.25 6.74993V11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25V6.74993L11.25 6.74993C11.6642 6.74993 12 6.41415 12 5.99993C12 5.58572 11.6642 5.24993 11.25 5.24993L6.75 5.24993V0.75Z"/>
            </svg>
        </div>
    </section-->

    <section id="search" class="pr-7 flex"> 
        <!--section class="form-input-text relative h-16 text-primary">
            <span class="absolute inset-y-0 left-0 h-16 z-10 flex items-center pl-6">
                <button type="submit" class="p-1 focus:outline-none focus:shadow-outline">
                    <svg width="20" height="21" viewBox="0 0 20 21" class="fill-primary" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.274 16.1191C13.8374 17.2947 12.0011 18 10.0001 18C5.39771 18 1.66675 14.269 1.66675 9.66666C1.66675 5.06429 5.39771 1.33333 10.0001 1.33333C14.6025 1.33333 18.3334 5.06429 18.3334 9.66666C18.3334 11.6677 17.6281 13.5041 16.4525 14.9406L18.9227 17.4108C19.2481 17.7362 19.2481 18.2639 18.9227 18.5893C18.5972 18.9147 18.0696 18.9147 17.7442 18.5893L15.274 16.1191ZM16.6667 9.66666C16.6667 13.3486 13.682 16.3333 10.0001 16.3333C6.31818 16.3333 3.33341 13.3486 3.33341 9.66666C3.33341 5.98476 6.31818 2.99999 10.0001 2.99999C13.682 2.99999 16.6667 5.98476 16.6667 9.66666Z"/>
                    </svg>
                </button>
            </span>
            <input type="text" style="width: 100%;" class="text-sm z-0 h-16 pl-14 shadow-xs placeholder-primary rounded-3xl focus:caret-primary border-primary border focus:ring-1 focus:ring-primary focus:outline-none focus:placeholder-shade" placeholder="Search" autocomplete="off" >
        </section-->
        <AutoComplete 
            placeholder="Search store"
            className="grow w-full" 
            inputClassName="p-2.5 m-0 border w-full grow" 
            hideArrow={true} 
            items="{$stores}" 
            bind:selectedItem={selectedOption} 
            labelFieldName="name" 
            valueFieldName="uid" 
            bind:text
            create={true}
            createText={"Store doesn't exist, create one?"}
            onCreate={createNewRetailer} 
        />
        <input type="submit" on:click|preventDefault={()=>setRetailer(selectedOption)} class="bg-primary text-secondary outline-1 p-0 m-0 text-center align-middle w-20 h-10 shrink-0" value="Select">
    </section>

    <section id="recent" class="flex space-y-5 flex-col items-stretch">
        <span class="pr-7 font-primaryBold text-2xl">Recent</span>
        <section id="recent-stores" class="flex space-x-5 overflow-auto no-scrollbar">
            {#if recentStores}
            {#each recentStores as recent}
                <section class="flex w-14 flex-col shrink-0" on:click={()=>setRetailer(recent)}>
                    <div class="bg-primary rounded-2xl w-12 h-12"><img class="m-auto w-8 mt-2" src="/img/stores/{recent.logoId}.png" alt=""/></div>
                    <div class="m-auto text-sm text-center place-self-center capitalize">{recent.name}</div>
                </section>
            {/each}
            {/if}
        </section>
    </section>

    <section id="all" class="flex flex-col pr-7 space-y-5 overflow-auto grow">
        <section class="flex">
            <span class=" font-primaryBold text-2xl">Stores</span>
            <div id="add-list" class="bg-secondary ml-4 w-7 h-7 place-self-center rounded-full text-center" on:click|stopPropagation={() => modal.open(`/new-store?list_uid=${list_uid}&anchor=bottom`)}>
                <svg class="m-auto mt-2 w-2.5 fill-accent" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.75 0.75C6.75 0.335786 6.41421 0 6 0C5.58579 0 5.25 0.335786 5.25 0.75V5.24993L0.75 5.24993C0.335786 5.24993 0 5.58572 0 5.99993C0 6.41414 0.335786 6.74993 0.75 6.74993L5.25 6.74993V11.25C5.25 11.6642 5.58579 12 6 12C6.41421 12 6.75 11.6642 6.75 11.25V6.74993L11.25 6.74993C11.6642 6.74993 12 6.41415 12 5.99993C12 5.58572 11.6642 5.24993 11.25 5.24993L6.75 5.24993V0.75Z"/>
                </svg>
            </div> 
        </section>
        <section id="all-list" class="flex space-y-5 flex-col grow overflow-scroll no-scrollbar">
            <!--{#each Object.keys($stores) as store}-->
            {#if $stores}
            {#each $stores as store}
                <section class="flex space-x-5" on:click={()=>setRetailer(store)}>      
                    <input type="radio" id="store-{store.uid}" />
                    <label for="store-{store.uid}" class="pr-8 text-primary mt-4.5 before:w-5 before:h-5"></label>
                    <div class="bg-primary rounded-2xl w-12 h-12" >
                        <img class="m-auto w-8 mt-2" src="/img/stores/{store.logoId}.png" alt=""/>
                    </div>
                    <div class="place-self-center capitalize">
                        {store.name}
                    </div>
                </section>
            {/each}
            {/if}
        </section>
    </section>

</section>       

<style lang="postcss">
input {
    height: 34px !important;
}
</style>
